import React from 'react';

// Minimalist line icons (stroke = currentColor so they inherit text color).
const svgProps = (size) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
});

export function BugIcon({ size = 18, ...rest }) {
  return (
    <svg {...svgProps(size)} {...rest} aria-hidden focusable="false">
      <path d="m8 2 1.88 1.88" />
      <path d="M14.12 3.88 16 2" />
      <path d="M9 7.13v-1a3.003 3.003 0 1 1 6 0v1" />
      <path d="M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6" />
      <path d="M12 20v-9" />
      <path d="M6.53 9C4.6 8.8 3 7.1 3 5" />
      <path d="M6 13H2" />
      <path d="M3 21c0-2.1 1.7-3.9 3.8-4" />
      <path d="M20.97 5c0 2.1-1.6 3.8-3.5 4" />
      <path d="M22 13h-4" />
      <path d="M17.2 17c2.1.1 3.8 1.9 3.8 4" />
    </svg>
  );
}

export function QuestionIcon({ size = 18, ...rest }) {
  return (
    <svg {...svgProps(size)} {...rest} aria-hidden focusable="false">
      <circle cx="12" cy="12" r="10" />
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
      <path d="M12 17h.01" />
    </svg>
  );
}

export function LightbulbIcon({ size = 18, ...rest }) {
  return (
    <svg {...svgProps(size)} {...rest} aria-hidden focusable="false">
      <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
      <path d="M9 18h6" />
      <path d="M10 22h4" />
    </svg>
  );
}

export function PaperclipIcon({ size = 18, ...rest }) {
  return (
    <svg {...svgProps(size)} {...rest} aria-hidden focusable="false">
      <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
    </svg>
  );
}

export function PersonIcon({ size = 18, ...rest }) {
  return (
    <svg {...svgProps(size)} {...rest} aria-hidden focusable="false">
      <circle cx="12" cy="8" r="3.5" />
      <path d="M5.5 20a6.5 6.5 0 0 1 13 0" />
    </svg>
  );
}

export function VideoIcon({ size = 18, ...rest }) {
  return (
    <svg {...svgProps(size)} {...rest} aria-hidden focusable="false">
      <path d="m22 8-6 4 6 4V8Z" />
      <rect width="14" height="12" x="2" y="6" rx="2" ry="2" />
    </svg>
  );
}

/** Icon for a case type. */
export function CaseTypeIcon({ type, ...rest }) {
  if (type === 'question') return <QuestionIcon {...rest} />;
  if (type === 'feature_request') return <LightbulbIcon {...rest} />;
  return <BugIcon {...rest} />;
}
